export default {"src":"/_next/static/media/bookmark.ee138383.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};